import React, { Component } from "react"
import URL from "url-parse"

import { images } from "../../config/image-definitions"
const { placeholderImage, brokenLinkImageSmall } = images

function getImageUrl(originalImageUrl, isLowmem, isThumbnail) {
    const provider = getImageProvider(originalImageUrl)
    switch (provider) {
        case "internal":
            return internalS3Url(originalImageUrl, isLowmem, isThumbnail)
        case "fws":
            return fwsUrl(originalImageUrl, isLowmem, isThumbnail)
        default:
            return originalImageUrl
    }
}

function getImageProvider(imageUrl) {
    if (imageUrl.includes("blob")) {
        return null
    } else if (
        (imageUrl.includes("s3") && imageUrl.includes("knowledge")) ||
        imageUrl.includes("contextualiq.org")
    ) {
        return "internal"
    } else if (imageUrl.includes("fws") && imageUrl.includes("weforum.org")) {
        return "fws"
    } else {
        return null
    }
}

function internalS3Url(imageToDownload, isLowmem, isThumbnail) {
    const parsedUrl = new URL(imageToDownload)
    let suffix = ""
    if (isLowmem) {
        suffix = "_lowmem"
    } else if (isThumbnail) {
        suffix = "_thumbnail"
    }
    parsedUrl.set("pathname", parsedUrl.pathname + suffix)
    return parsedUrl.toString()
}

function fwsUrl(imageToDownload, isLowmem, isThumbnail) {
    const parsedUrl = new URL(imageToDownload)
    let newPath = parsedUrl.pathname
    if (
        newPath.endsWith("/standard") ||
        newPath.endsWith("/original") ||
        newPath.endsWith("/thumbnail")
    ) {
        const parts = newPath.split("/")
        parts.pop(-1)
        newPath = parts.join("/")
    }
    let suffix = ""
    if (isLowmem || isThumbnail) {
        suffix = "standard"
    } else {
        suffix = "original"
    }
    parsedUrl.set("pathname", `${newPath}/${suffix}`)
    return parsedUrl.toString()
}

class BackgroundImage extends Component {
    state = {
        imageUrl: "",
        isImageLoaded: false
    }

    componentDidMount() {
        this.displayImage = new window.Image()
        const {
            imageUrl,
            defaultImageUrl,
            errorImageUrl,
            isLowmem,
            isThumbnail
        } = this.props
        this.setDisplayImage(
            imageUrl,
            defaultImageUrl,
            errorImageUrl,
            isLowmem,
            isThumbnail
        )
    }

    setDisplayImage = (
        imageUrl,
        defaultImageUrl = placeholderImage,
        errorImageUrl = brokenLinkImageSmall,
        isLowmem,
        isThumbnail
    ) => {
        this.setState({
            imageUrl: defaultImageUrl,
            isImageLoaded: !imageUrl
        })
        if (imageUrl) {
            const imageToDownload = getImageUrl(imageUrl, isLowmem, isThumbnail)
            this.displayImage.src = imageToDownload
            this.displayImage.onload = () => {
                this.setState({
                    imageUrl: imageToDownload,
                    isImageLoaded: true
                })
            }
            this.displayImage.onerror = () => {
                if (isLowmem || isThumbnail)
                    // Try it again without any additional suffixes
                    this.setDisplayImage(
                        imageUrl,
                        defaultImageUrl,
                        errorImageUrl
                    )
                else {
                    this.setState({
                        imageUrl: errorImageUrl,
                        isImageLoaded: true
                    })
                }
            }
        }
    }

    UNSAFE_componentWillReceiveProps({
        imageUrl,
        defaultImageUrl = placeholderImage,
        errorImageUrl = brokenLinkImageSmall,
        isLowmem,
        isThumbnail
    }) {
        if (imageUrl !== this.props.imageUrl) {
            this.setDisplayImage(
                imageUrl,
                defaultImageUrl,
                errorImageUrl,
                isLowmem,
                isThumbnail
            )
        }
    }

    componentWillUnmount() {
        this.displayImage.onload = null
        this.displayImage.onerror = null
        this.displayImage = null
    }

    render() {
        const { id, onClick, children } = this.props
        const classList = [
            ...(this.props.classList || []),
            "background-image-opacity-transition"
        ]
        if (this.state.isImageLoaded) classList.push("full-background-opacity")
        return (
            <div
                {...{ id, onClick }}
                className={classList.join(" ")}
                style={{ backgroundImage: `url(${this.state.imageUrl})` }}
            >
                {children}
            </div>
        )
    }
}

export default BackgroundImage
